// source: pangolin/protos/update.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */


var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.pangolin.protos.CreateUpdateRestoreRequest', null, global);
goog.exportSymbol('proto.pangolin.protos.CreateUpdateRestoreResponse', null, global);
goog.exportSymbol('proto.pangolin.protos.CreateUpdateUpgradeRequest', null, global);
goog.exportSymbol('proto.pangolin.protos.CreateUpdateUpgradeResponse', null, global);
goog.exportSymbol('proto.pangolin.protos.DeleteUpdateSnapshotRequest', null, global);
goog.exportSymbol('proto.pangolin.protos.DownloadUpdateSnapshotResponse', null, global);
goog.exportSymbol('proto.pangolin.protos.GetUpdateHistoryResponse', null, global);
goog.exportSymbol('proto.pangolin.protos.GetUpdateReleaseResponse', null, global);
goog.exportSymbol('proto.pangolin.protos.GetUpdateReleasesResponse', null, global);
goog.exportSymbol('proto.pangolin.protos.GetUpdateRestoreResponse', null, global);
goog.exportSymbol('proto.pangolin.protos.GetUpdateSnapshotResponse', null, global);
goog.exportSymbol('proto.pangolin.protos.GetUpdateSnapshotsResponse', null, global);
goog.exportSymbol('proto.pangolin.protos.GetUpdateUpgradeResponse', null, global);
goog.exportSymbol('proto.pangolin.protos.SetUpdateRestoreStatusRequest', null, global);
goog.exportSymbol('proto.pangolin.protos.SetUpdateUpgradeStatusRequest', null, global);
goog.exportSymbol('proto.pangolin.protos.UpdateHistoryObject', null, global);
goog.exportSymbol('proto.pangolin.protos.UpdateHistoryObject.IdCase', null, global);
goog.exportSymbol('proto.pangolin.protos.UpdateHistoryType', null, global);
goog.exportSymbol('proto.pangolin.protos.UpdateReleaseObject', null, global);
goog.exportSymbol('proto.pangolin.protos.UpdateRestoreObject', null, global);
goog.exportSymbol('proto.pangolin.protos.UpdateRestoreStatus', null, global);
goog.exportSymbol('proto.pangolin.protos.UpdateSnapshotObject', null, global);
goog.exportSymbol('proto.pangolin.protos.UpdateUpgradeObject', null, global);
goog.exportSymbol('proto.pangolin.protos.UpdateUpgradeStatus', null, global);
goog.exportSymbol('proto.pangolin.protos.UploadFinishUpdateSnapshotRequest', null, global);
goog.exportSymbol('proto.pangolin.protos.UploadStartUpdateSnapshotRequest', null, global);
goog.exportSymbol('proto.pangolin.protos.UploadStartUpdateSnapshotResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.UpdateReleaseObject = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.UpdateReleaseObject, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.UpdateReleaseObject.displayName = 'proto.pangolin.protos.UpdateReleaseObject';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.UpdateSnapshotObject = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.UpdateSnapshotObject, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.UpdateSnapshotObject.displayName = 'proto.pangolin.protos.UpdateSnapshotObject';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.UpdateUpgradeObject = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.UpdateUpgradeObject, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.UpdateUpgradeObject.displayName = 'proto.pangolin.protos.UpdateUpgradeObject';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.UpdateRestoreObject = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.UpdateRestoreObject, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.UpdateRestoreObject.displayName = 'proto.pangolin.protos.UpdateRestoreObject';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.UpdateHistoryObject = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.pangolin.protos.UpdateHistoryObject.oneofGroups_);
};
goog.inherits(proto.pangolin.protos.UpdateHistoryObject, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.UpdateHistoryObject.displayName = 'proto.pangolin.protos.UpdateHistoryObject';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.GetUpdateReleasesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pangolin.protos.GetUpdateReleasesResponse.repeatedFields_, null);
};
goog.inherits(proto.pangolin.protos.GetUpdateReleasesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.GetUpdateReleasesResponse.displayName = 'proto.pangolin.protos.GetUpdateReleasesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.GetUpdateReleaseResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.GetUpdateReleaseResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.GetUpdateReleaseResponse.displayName = 'proto.pangolin.protos.GetUpdateReleaseResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.GetUpdateSnapshotsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pangolin.protos.GetUpdateSnapshotsResponse.repeatedFields_, null);
};
goog.inherits(proto.pangolin.protos.GetUpdateSnapshotsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.GetUpdateSnapshotsResponse.displayName = 'proto.pangolin.protos.GetUpdateSnapshotsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.GetUpdateSnapshotResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.GetUpdateSnapshotResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.GetUpdateSnapshotResponse.displayName = 'proto.pangolin.protos.GetUpdateSnapshotResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.DeleteUpdateSnapshotRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.DeleteUpdateSnapshotRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.DeleteUpdateSnapshotRequest.displayName = 'proto.pangolin.protos.DeleteUpdateSnapshotRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.UploadStartUpdateSnapshotRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.UploadStartUpdateSnapshotRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.UploadStartUpdateSnapshotRequest.displayName = 'proto.pangolin.protos.UploadStartUpdateSnapshotRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.UploadStartUpdateSnapshotResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.UploadStartUpdateSnapshotResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.UploadStartUpdateSnapshotResponse.displayName = 'proto.pangolin.protos.UploadStartUpdateSnapshotResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.UploadFinishUpdateSnapshotRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.UploadFinishUpdateSnapshotRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.UploadFinishUpdateSnapshotRequest.displayName = 'proto.pangolin.protos.UploadFinishUpdateSnapshotRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.DownloadUpdateSnapshotResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.DownloadUpdateSnapshotResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.DownloadUpdateSnapshotResponse.displayName = 'proto.pangolin.protos.DownloadUpdateSnapshotResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.GetUpdateHistoryResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pangolin.protos.GetUpdateHistoryResponse.repeatedFields_, null);
};
goog.inherits(proto.pangolin.protos.GetUpdateHistoryResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.GetUpdateHistoryResponse.displayName = 'proto.pangolin.protos.GetUpdateHistoryResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.GetUpdateUpgradeResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.GetUpdateUpgradeResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.GetUpdateUpgradeResponse.displayName = 'proto.pangolin.protos.GetUpdateUpgradeResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.CreateUpdateUpgradeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.CreateUpdateUpgradeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.CreateUpdateUpgradeRequest.displayName = 'proto.pangolin.protos.CreateUpdateUpgradeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.CreateUpdateUpgradeResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.CreateUpdateUpgradeResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.CreateUpdateUpgradeResponse.displayName = 'proto.pangolin.protos.CreateUpdateUpgradeResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.SetUpdateUpgradeStatusRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.SetUpdateUpgradeStatusRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.SetUpdateUpgradeStatusRequest.displayName = 'proto.pangolin.protos.SetUpdateUpgradeStatusRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.GetUpdateRestoreResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.GetUpdateRestoreResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.GetUpdateRestoreResponse.displayName = 'proto.pangolin.protos.GetUpdateRestoreResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.CreateUpdateRestoreRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.CreateUpdateRestoreRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.CreateUpdateRestoreRequest.displayName = 'proto.pangolin.protos.CreateUpdateRestoreRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.CreateUpdateRestoreResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.CreateUpdateRestoreResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.CreateUpdateRestoreResponse.displayName = 'proto.pangolin.protos.CreateUpdateRestoreResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.SetUpdateRestoreStatusRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.SetUpdateRestoreStatusRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.SetUpdateRestoreStatusRequest.displayName = 'proto.pangolin.protos.SetUpdateRestoreStatusRequest';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.UpdateReleaseObject.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.UpdateReleaseObject.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.UpdateReleaseObject} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.UpdateReleaseObject.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
    tag: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
    notes: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f,
    isEnabled: (f = jspb.Message.getBooleanField(msg, 4)) == null ? undefined : f,
    createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.UpdateReleaseObject}
 */
proto.pangolin.protos.UpdateReleaseObject.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.UpdateReleaseObject;
  return proto.pangolin.protos.UpdateReleaseObject.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.UpdateReleaseObject} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.UpdateReleaseObject}
 */
proto.pangolin.protos.UpdateReleaseObject.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTag(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setNotes(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsEnabled(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 6:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdatedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.UpdateReleaseObject.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.UpdateReleaseObject.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.UpdateReleaseObject} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.UpdateReleaseObject.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.pangolin.protos.UpdateReleaseObject.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.UpdateReleaseObject} returns this
 */
proto.pangolin.protos.UpdateReleaseObject.prototype.setId = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.UpdateReleaseObject} returns this
 */
proto.pangolin.protos.UpdateReleaseObject.prototype.clearId = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.UpdateReleaseObject.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string tag = 2;
 * @return {string}
 */
proto.pangolin.protos.UpdateReleaseObject.prototype.getTag = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.UpdateReleaseObject} returns this
 */
proto.pangolin.protos.UpdateReleaseObject.prototype.setTag = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.UpdateReleaseObject} returns this
 */
proto.pangolin.protos.UpdateReleaseObject.prototype.clearTag = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.UpdateReleaseObject.prototype.hasTag = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string notes = 3;
 * @return {string}
 */
proto.pangolin.protos.UpdateReleaseObject.prototype.getNotes = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.UpdateReleaseObject} returns this
 */
proto.pangolin.protos.UpdateReleaseObject.prototype.setNotes = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.UpdateReleaseObject} returns this
 */
proto.pangolin.protos.UpdateReleaseObject.prototype.clearNotes = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.UpdateReleaseObject.prototype.hasNotes = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional bool is_enabled = 4;
 * @return {boolean}
 */
proto.pangolin.protos.UpdateReleaseObject.prototype.getIsEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pangolin.protos.UpdateReleaseObject} returns this
 */
proto.pangolin.protos.UpdateReleaseObject.prototype.setIsEnabled = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.UpdateReleaseObject} returns this
 */
proto.pangolin.protos.UpdateReleaseObject.prototype.clearIsEnabled = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.UpdateReleaseObject.prototype.hasIsEnabled = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.Timestamp created_at = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.pangolin.protos.UpdateReleaseObject.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.pangolin.protos.UpdateReleaseObject} returns this
*/
proto.pangolin.protos.UpdateReleaseObject.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pangolin.protos.UpdateReleaseObject} returns this
 */
proto.pangolin.protos.UpdateReleaseObject.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.UpdateReleaseObject.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.Timestamp updated_at = 6;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.pangolin.protos.UpdateReleaseObject.prototype.getUpdatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 6));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.pangolin.protos.UpdateReleaseObject} returns this
*/
proto.pangolin.protos.UpdateReleaseObject.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pangolin.protos.UpdateReleaseObject} returns this
 */
proto.pangolin.protos.UpdateReleaseObject.prototype.clearUpdatedAt = function() {
  return this.setUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.UpdateReleaseObject.prototype.hasUpdatedAt = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.UpdateSnapshotObject.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.UpdateSnapshotObject.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.UpdateSnapshotObject} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.UpdateSnapshotObject.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
    releaseId: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
    isEnabled: (f = jspb.Message.getBooleanField(msg, 3)) == null ? undefined : f,
    createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    size: (f = jspb.Message.getField(msg, 6)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.UpdateSnapshotObject}
 */
proto.pangolin.protos.UpdateSnapshotObject.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.UpdateSnapshotObject;
  return proto.pangolin.protos.UpdateSnapshotObject.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.UpdateSnapshotObject} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.UpdateSnapshotObject}
 */
proto.pangolin.protos.UpdateSnapshotObject.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setReleaseId(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsEnabled(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdatedAt(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.UpdateSnapshotObject.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.UpdateSnapshotObject.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.UpdateSnapshotObject} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.UpdateSnapshotObject.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeInt64(
      6,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.pangolin.protos.UpdateSnapshotObject.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.UpdateSnapshotObject} returns this
 */
proto.pangolin.protos.UpdateSnapshotObject.prototype.setId = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.UpdateSnapshotObject} returns this
 */
proto.pangolin.protos.UpdateSnapshotObject.prototype.clearId = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.UpdateSnapshotObject.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string release_id = 2;
 * @return {string}
 */
proto.pangolin.protos.UpdateSnapshotObject.prototype.getReleaseId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.UpdateSnapshotObject} returns this
 */
proto.pangolin.protos.UpdateSnapshotObject.prototype.setReleaseId = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.UpdateSnapshotObject} returns this
 */
proto.pangolin.protos.UpdateSnapshotObject.prototype.clearReleaseId = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.UpdateSnapshotObject.prototype.hasReleaseId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional bool is_enabled = 3;
 * @return {boolean}
 */
proto.pangolin.protos.UpdateSnapshotObject.prototype.getIsEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pangolin.protos.UpdateSnapshotObject} returns this
 */
proto.pangolin.protos.UpdateSnapshotObject.prototype.setIsEnabled = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.UpdateSnapshotObject} returns this
 */
proto.pangolin.protos.UpdateSnapshotObject.prototype.clearIsEnabled = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.UpdateSnapshotObject.prototype.hasIsEnabled = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.Timestamp created_at = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.pangolin.protos.UpdateSnapshotObject.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.pangolin.protos.UpdateSnapshotObject} returns this
*/
proto.pangolin.protos.UpdateSnapshotObject.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pangolin.protos.UpdateSnapshotObject} returns this
 */
proto.pangolin.protos.UpdateSnapshotObject.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.UpdateSnapshotObject.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.Timestamp updated_at = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.pangolin.protos.UpdateSnapshotObject.prototype.getUpdatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.pangolin.protos.UpdateSnapshotObject} returns this
*/
proto.pangolin.protos.UpdateSnapshotObject.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pangolin.protos.UpdateSnapshotObject} returns this
 */
proto.pangolin.protos.UpdateSnapshotObject.prototype.clearUpdatedAt = function() {
  return this.setUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.UpdateSnapshotObject.prototype.hasUpdatedAt = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional int64 size = 6;
 * @return {number}
 */
proto.pangolin.protos.UpdateSnapshotObject.prototype.getSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.pangolin.protos.UpdateSnapshotObject} returns this
 */
proto.pangolin.protos.UpdateSnapshotObject.prototype.setSize = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.UpdateSnapshotObject} returns this
 */
proto.pangolin.protos.UpdateSnapshotObject.prototype.clearSize = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.UpdateSnapshotObject.prototype.hasSize = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.UpdateUpgradeObject.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.UpdateUpgradeObject.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.UpdateUpgradeObject} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.UpdateUpgradeObject.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
    sourceReleaseId: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
    targetReleaseId: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f,
    status: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f,
    createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    terminalStatus: (f = jspb.Message.getField(msg, 7)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.UpdateUpgradeObject}
 */
proto.pangolin.protos.UpdateUpgradeObject.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.UpdateUpgradeObject;
  return proto.pangolin.protos.UpdateUpgradeObject.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.UpdateUpgradeObject} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.UpdateUpgradeObject}
 */
proto.pangolin.protos.UpdateUpgradeObject.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSourceReleaseId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTargetReleaseId(value);
      break;
    case 4:
      var value = /** @type {!proto.pangolin.protos.UpdateUpgradeStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 6:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdatedAt(value);
      break;
    case 7:
      var value = /** @type {!proto.pangolin.protos.UpdateUpgradeStatus} */ (reader.readEnum());
      msg.setTerminalStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.UpdateUpgradeObject.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.UpdateUpgradeObject.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.UpdateUpgradeObject} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.UpdateUpgradeObject.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
  f = /** @type {!proto.pangolin.protos.UpdateUpgradeStatus} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = /** @type {!proto.pangolin.protos.UpdateUpgradeStatus} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeEnum(
      7,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.pangolin.protos.UpdateUpgradeObject.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.UpdateUpgradeObject} returns this
 */
proto.pangolin.protos.UpdateUpgradeObject.prototype.setId = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.UpdateUpgradeObject} returns this
 */
proto.pangolin.protos.UpdateUpgradeObject.prototype.clearId = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.UpdateUpgradeObject.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string source_release_id = 2;
 * @return {string}
 */
proto.pangolin.protos.UpdateUpgradeObject.prototype.getSourceReleaseId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.UpdateUpgradeObject} returns this
 */
proto.pangolin.protos.UpdateUpgradeObject.prototype.setSourceReleaseId = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.UpdateUpgradeObject} returns this
 */
proto.pangolin.protos.UpdateUpgradeObject.prototype.clearSourceReleaseId = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.UpdateUpgradeObject.prototype.hasSourceReleaseId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string target_release_id = 3;
 * @return {string}
 */
proto.pangolin.protos.UpdateUpgradeObject.prototype.getTargetReleaseId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.UpdateUpgradeObject} returns this
 */
proto.pangolin.protos.UpdateUpgradeObject.prototype.setTargetReleaseId = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.UpdateUpgradeObject} returns this
 */
proto.pangolin.protos.UpdateUpgradeObject.prototype.clearTargetReleaseId = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.UpdateUpgradeObject.prototype.hasTargetReleaseId = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional UpdateUpgradeStatus status = 4;
 * @return {!proto.pangolin.protos.UpdateUpgradeStatus}
 */
proto.pangolin.protos.UpdateUpgradeObject.prototype.getStatus = function() {
  return /** @type {!proto.pangolin.protos.UpdateUpgradeStatus} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.pangolin.protos.UpdateUpgradeStatus} value
 * @return {!proto.pangolin.protos.UpdateUpgradeObject} returns this
 */
proto.pangolin.protos.UpdateUpgradeObject.prototype.setStatus = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.UpdateUpgradeObject} returns this
 */
proto.pangolin.protos.UpdateUpgradeObject.prototype.clearStatus = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.UpdateUpgradeObject.prototype.hasStatus = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.Timestamp created_at = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.pangolin.protos.UpdateUpgradeObject.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.pangolin.protos.UpdateUpgradeObject} returns this
*/
proto.pangolin.protos.UpdateUpgradeObject.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pangolin.protos.UpdateUpgradeObject} returns this
 */
proto.pangolin.protos.UpdateUpgradeObject.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.UpdateUpgradeObject.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.Timestamp updated_at = 6;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.pangolin.protos.UpdateUpgradeObject.prototype.getUpdatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 6));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.pangolin.protos.UpdateUpgradeObject} returns this
*/
proto.pangolin.protos.UpdateUpgradeObject.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pangolin.protos.UpdateUpgradeObject} returns this
 */
proto.pangolin.protos.UpdateUpgradeObject.prototype.clearUpdatedAt = function() {
  return this.setUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.UpdateUpgradeObject.prototype.hasUpdatedAt = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional UpdateUpgradeStatus terminal_status = 7;
 * @return {!proto.pangolin.protos.UpdateUpgradeStatus}
 */
proto.pangolin.protos.UpdateUpgradeObject.prototype.getTerminalStatus = function() {
  return /** @type {!proto.pangolin.protos.UpdateUpgradeStatus} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.pangolin.protos.UpdateUpgradeStatus} value
 * @return {!proto.pangolin.protos.UpdateUpgradeObject} returns this
 */
proto.pangolin.protos.UpdateUpgradeObject.prototype.setTerminalStatus = function(value) {
  return jspb.Message.setField(this, 7, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.UpdateUpgradeObject} returns this
 */
proto.pangolin.protos.UpdateUpgradeObject.prototype.clearTerminalStatus = function() {
  return jspb.Message.setField(this, 7, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.UpdateUpgradeObject.prototype.hasTerminalStatus = function() {
  return jspb.Message.getField(this, 7) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.UpdateRestoreObject.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.UpdateRestoreObject.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.UpdateRestoreObject} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.UpdateRestoreObject.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
    sourceReleaseId: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
    targetReleaseId: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f,
    targetSnapshotId: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f,
    status: (f = jspb.Message.getField(msg, 5)) == null ? undefined : f,
    createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    terminalStatus: (f = jspb.Message.getField(msg, 8)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.UpdateRestoreObject}
 */
proto.pangolin.protos.UpdateRestoreObject.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.UpdateRestoreObject;
  return proto.pangolin.protos.UpdateRestoreObject.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.UpdateRestoreObject} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.UpdateRestoreObject}
 */
proto.pangolin.protos.UpdateRestoreObject.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSourceReleaseId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTargetReleaseId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTargetSnapshotId(value);
      break;
    case 5:
      var value = /** @type {!proto.pangolin.protos.UpdateRestoreStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 6:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 7:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdatedAt(value);
      break;
    case 8:
      var value = /** @type {!proto.pangolin.protos.UpdateRestoreStatus} */ (reader.readEnum());
      msg.setTerminalStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.UpdateRestoreObject.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.UpdateRestoreObject.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.UpdateRestoreObject} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.UpdateRestoreObject.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
  f = /** @type {!proto.pangolin.protos.UpdateRestoreStatus} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = /** @type {!proto.pangolin.protos.UpdateRestoreStatus} */ (jspb.Message.getField(message, 8));
  if (f != null) {
    writer.writeEnum(
      8,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.pangolin.protos.UpdateRestoreObject.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.UpdateRestoreObject} returns this
 */
proto.pangolin.protos.UpdateRestoreObject.prototype.setId = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.UpdateRestoreObject} returns this
 */
proto.pangolin.protos.UpdateRestoreObject.prototype.clearId = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.UpdateRestoreObject.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string source_release_id = 2;
 * @return {string}
 */
proto.pangolin.protos.UpdateRestoreObject.prototype.getSourceReleaseId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.UpdateRestoreObject} returns this
 */
proto.pangolin.protos.UpdateRestoreObject.prototype.setSourceReleaseId = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.UpdateRestoreObject} returns this
 */
proto.pangolin.protos.UpdateRestoreObject.prototype.clearSourceReleaseId = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.UpdateRestoreObject.prototype.hasSourceReleaseId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string target_release_id = 3;
 * @return {string}
 */
proto.pangolin.protos.UpdateRestoreObject.prototype.getTargetReleaseId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.UpdateRestoreObject} returns this
 */
proto.pangolin.protos.UpdateRestoreObject.prototype.setTargetReleaseId = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.UpdateRestoreObject} returns this
 */
proto.pangolin.protos.UpdateRestoreObject.prototype.clearTargetReleaseId = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.UpdateRestoreObject.prototype.hasTargetReleaseId = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string target_snapshot_id = 4;
 * @return {string}
 */
proto.pangolin.protos.UpdateRestoreObject.prototype.getTargetSnapshotId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.UpdateRestoreObject} returns this
 */
proto.pangolin.protos.UpdateRestoreObject.prototype.setTargetSnapshotId = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.UpdateRestoreObject} returns this
 */
proto.pangolin.protos.UpdateRestoreObject.prototype.clearTargetSnapshotId = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.UpdateRestoreObject.prototype.hasTargetSnapshotId = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional UpdateRestoreStatus status = 5;
 * @return {!proto.pangolin.protos.UpdateRestoreStatus}
 */
proto.pangolin.protos.UpdateRestoreObject.prototype.getStatus = function() {
  return /** @type {!proto.pangolin.protos.UpdateRestoreStatus} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.pangolin.protos.UpdateRestoreStatus} value
 * @return {!proto.pangolin.protos.UpdateRestoreObject} returns this
 */
proto.pangolin.protos.UpdateRestoreObject.prototype.setStatus = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.UpdateRestoreObject} returns this
 */
proto.pangolin.protos.UpdateRestoreObject.prototype.clearStatus = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.UpdateRestoreObject.prototype.hasStatus = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.Timestamp created_at = 6;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.pangolin.protos.UpdateRestoreObject.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 6));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.pangolin.protos.UpdateRestoreObject} returns this
*/
proto.pangolin.protos.UpdateRestoreObject.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pangolin.protos.UpdateRestoreObject} returns this
 */
proto.pangolin.protos.UpdateRestoreObject.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.UpdateRestoreObject.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional google.protobuf.Timestamp updated_at = 7;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.pangolin.protos.UpdateRestoreObject.prototype.getUpdatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 7));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.pangolin.protos.UpdateRestoreObject} returns this
*/
proto.pangolin.protos.UpdateRestoreObject.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pangolin.protos.UpdateRestoreObject} returns this
 */
proto.pangolin.protos.UpdateRestoreObject.prototype.clearUpdatedAt = function() {
  return this.setUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.UpdateRestoreObject.prototype.hasUpdatedAt = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional UpdateRestoreStatus terminal_status = 8;
 * @return {!proto.pangolin.protos.UpdateRestoreStatus}
 */
proto.pangolin.protos.UpdateRestoreObject.prototype.getTerminalStatus = function() {
  return /** @type {!proto.pangolin.protos.UpdateRestoreStatus} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.pangolin.protos.UpdateRestoreStatus} value
 * @return {!proto.pangolin.protos.UpdateRestoreObject} returns this
 */
proto.pangolin.protos.UpdateRestoreObject.prototype.setTerminalStatus = function(value) {
  return jspb.Message.setField(this, 8, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.UpdateRestoreObject} returns this
 */
proto.pangolin.protos.UpdateRestoreObject.prototype.clearTerminalStatus = function() {
  return jspb.Message.setField(this, 8, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.UpdateRestoreObject.prototype.hasTerminalStatus = function() {
  return jspb.Message.getField(this, 8) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.pangolin.protos.UpdateHistoryObject.oneofGroups_ = [[2,3]];

/**
 * @enum {number}
 */
proto.pangolin.protos.UpdateHistoryObject.IdCase = {
  ID_NOT_SET: 0,
  UPGRADE: 2,
  RESTORE: 3
};

/**
 * @return {proto.pangolin.protos.UpdateHistoryObject.IdCase}
 */
proto.pangolin.protos.UpdateHistoryObject.prototype.getIdCase = function() {
  return /** @type {proto.pangolin.protos.UpdateHistoryObject.IdCase} */(jspb.Message.computeOneofCase(this, proto.pangolin.protos.UpdateHistoryObject.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.UpdateHistoryObject.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.UpdateHistoryObject.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.UpdateHistoryObject} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.UpdateHistoryObject.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
    upgrade: (f = msg.getUpgrade()) && proto.pangolin.protos.UpdateUpgradeObject.toObject(includeInstance, f),
    restore: (f = msg.getRestore()) && proto.pangolin.protos.UpdateRestoreObject.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.UpdateHistoryObject}
 */
proto.pangolin.protos.UpdateHistoryObject.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.UpdateHistoryObject;
  return proto.pangolin.protos.UpdateHistoryObject.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.UpdateHistoryObject} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.UpdateHistoryObject}
 */
proto.pangolin.protos.UpdateHistoryObject.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.pangolin.protos.UpdateHistoryType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 2:
      var value = new proto.pangolin.protos.UpdateUpgradeObject;
      reader.readMessage(value,proto.pangolin.protos.UpdateUpgradeObject.deserializeBinaryFromReader);
      msg.setUpgrade(value);
      break;
    case 3:
      var value = new proto.pangolin.protos.UpdateRestoreObject;
      reader.readMessage(value,proto.pangolin.protos.UpdateRestoreObject.deserializeBinaryFromReader);
      msg.setRestore(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.UpdateHistoryObject.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.UpdateHistoryObject.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.UpdateHistoryObject} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.UpdateHistoryObject.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {!proto.pangolin.protos.UpdateHistoryType} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getUpgrade();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.pangolin.protos.UpdateUpgradeObject.serializeBinaryToWriter
    );
  }
  f = message.getRestore();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.pangolin.protos.UpdateRestoreObject.serializeBinaryToWriter
    );
  }
};


/**
 * optional UpdateHistoryType type = 1;
 * @return {!proto.pangolin.protos.UpdateHistoryType}
 */
proto.pangolin.protos.UpdateHistoryObject.prototype.getType = function() {
  return /** @type {!proto.pangolin.protos.UpdateHistoryType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.pangolin.protos.UpdateHistoryType} value
 * @return {!proto.pangolin.protos.UpdateHistoryObject} returns this
 */
proto.pangolin.protos.UpdateHistoryObject.prototype.setType = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.UpdateHistoryObject} returns this
 */
proto.pangolin.protos.UpdateHistoryObject.prototype.clearType = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.UpdateHistoryObject.prototype.hasType = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional UpdateUpgradeObject upgrade = 2;
 * @return {?proto.pangolin.protos.UpdateUpgradeObject}
 */
proto.pangolin.protos.UpdateHistoryObject.prototype.getUpgrade = function() {
  return /** @type{?proto.pangolin.protos.UpdateUpgradeObject} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.UpdateUpgradeObject, 2));
};


/**
 * @param {?proto.pangolin.protos.UpdateUpgradeObject|undefined} value
 * @return {!proto.pangolin.protos.UpdateHistoryObject} returns this
*/
proto.pangolin.protos.UpdateHistoryObject.prototype.setUpgrade = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.pangolin.protos.UpdateHistoryObject.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pangolin.protos.UpdateHistoryObject} returns this
 */
proto.pangolin.protos.UpdateHistoryObject.prototype.clearUpgrade = function() {
  return this.setUpgrade(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.UpdateHistoryObject.prototype.hasUpgrade = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional UpdateRestoreObject restore = 3;
 * @return {?proto.pangolin.protos.UpdateRestoreObject}
 */
proto.pangolin.protos.UpdateHistoryObject.prototype.getRestore = function() {
  return /** @type{?proto.pangolin.protos.UpdateRestoreObject} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.UpdateRestoreObject, 3));
};


/**
 * @param {?proto.pangolin.protos.UpdateRestoreObject|undefined} value
 * @return {!proto.pangolin.protos.UpdateHistoryObject} returns this
*/
proto.pangolin.protos.UpdateHistoryObject.prototype.setRestore = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.pangolin.protos.UpdateHistoryObject.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pangolin.protos.UpdateHistoryObject} returns this
 */
proto.pangolin.protos.UpdateHistoryObject.prototype.clearRestore = function() {
  return this.setRestore(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.UpdateHistoryObject.prototype.hasRestore = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pangolin.protos.GetUpdateReleasesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.GetUpdateReleasesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.GetUpdateReleasesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.GetUpdateReleasesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.GetUpdateReleasesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    releasesList: jspb.Message.toObjectList(msg.getReleasesList(),
    proto.pangolin.protos.UpdateReleaseObject.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.GetUpdateReleasesResponse}
 */
proto.pangolin.protos.GetUpdateReleasesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.GetUpdateReleasesResponse;
  return proto.pangolin.protos.GetUpdateReleasesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.GetUpdateReleasesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.GetUpdateReleasesResponse}
 */
proto.pangolin.protos.GetUpdateReleasesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.UpdateReleaseObject;
      reader.readMessage(value,proto.pangolin.protos.UpdateReleaseObject.deserializeBinaryFromReader);
      msg.addReleases(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.GetUpdateReleasesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.GetUpdateReleasesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.GetUpdateReleasesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.GetUpdateReleasesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReleasesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.pangolin.protos.UpdateReleaseObject.serializeBinaryToWriter
    );
  }
};


/**
 * repeated UpdateReleaseObject releases = 1;
 * @return {!Array<!proto.pangolin.protos.UpdateReleaseObject>}
 */
proto.pangolin.protos.GetUpdateReleasesResponse.prototype.getReleasesList = function() {
  return /** @type{!Array<!proto.pangolin.protos.UpdateReleaseObject>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.pangolin.protos.UpdateReleaseObject, 1));
};


/**
 * @param {!Array<!proto.pangolin.protos.UpdateReleaseObject>} value
 * @return {!proto.pangolin.protos.GetUpdateReleasesResponse} returns this
*/
proto.pangolin.protos.GetUpdateReleasesResponse.prototype.setReleasesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.pangolin.protos.UpdateReleaseObject=} opt_value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.UpdateReleaseObject}
 */
proto.pangolin.protos.GetUpdateReleasesResponse.prototype.addReleases = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.pangolin.protos.UpdateReleaseObject, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.GetUpdateReleasesResponse} returns this
 */
proto.pangolin.protos.GetUpdateReleasesResponse.prototype.clearReleasesList = function() {
  return this.setReleasesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.GetUpdateReleaseResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.GetUpdateReleaseResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.GetUpdateReleaseResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.GetUpdateReleaseResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    release: (f = msg.getRelease()) && proto.pangolin.protos.UpdateReleaseObject.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.GetUpdateReleaseResponse}
 */
proto.pangolin.protos.GetUpdateReleaseResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.GetUpdateReleaseResponse;
  return proto.pangolin.protos.GetUpdateReleaseResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.GetUpdateReleaseResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.GetUpdateReleaseResponse}
 */
proto.pangolin.protos.GetUpdateReleaseResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.UpdateReleaseObject;
      reader.readMessage(value,proto.pangolin.protos.UpdateReleaseObject.deserializeBinaryFromReader);
      msg.setRelease(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.GetUpdateReleaseResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.GetUpdateReleaseResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.GetUpdateReleaseResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.GetUpdateReleaseResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRelease();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pangolin.protos.UpdateReleaseObject.serializeBinaryToWriter
    );
  }
};


/**
 * optional UpdateReleaseObject release = 1;
 * @return {?proto.pangolin.protos.UpdateReleaseObject}
 */
proto.pangolin.protos.GetUpdateReleaseResponse.prototype.getRelease = function() {
  return /** @type{?proto.pangolin.protos.UpdateReleaseObject} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.UpdateReleaseObject, 1));
};


/**
 * @param {?proto.pangolin.protos.UpdateReleaseObject|undefined} value
 * @return {!proto.pangolin.protos.GetUpdateReleaseResponse} returns this
*/
proto.pangolin.protos.GetUpdateReleaseResponse.prototype.setRelease = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pangolin.protos.GetUpdateReleaseResponse} returns this
 */
proto.pangolin.protos.GetUpdateReleaseResponse.prototype.clearRelease = function() {
  return this.setRelease(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.GetUpdateReleaseResponse.prototype.hasRelease = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pangolin.protos.GetUpdateSnapshotsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.GetUpdateSnapshotsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.GetUpdateSnapshotsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.GetUpdateSnapshotsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.GetUpdateSnapshotsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    snapshotsList: jspb.Message.toObjectList(msg.getSnapshotsList(),
    proto.pangolin.protos.UpdateSnapshotObject.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.GetUpdateSnapshotsResponse}
 */
proto.pangolin.protos.GetUpdateSnapshotsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.GetUpdateSnapshotsResponse;
  return proto.pangolin.protos.GetUpdateSnapshotsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.GetUpdateSnapshotsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.GetUpdateSnapshotsResponse}
 */
proto.pangolin.protos.GetUpdateSnapshotsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.UpdateSnapshotObject;
      reader.readMessage(value,proto.pangolin.protos.UpdateSnapshotObject.deserializeBinaryFromReader);
      msg.addSnapshots(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.GetUpdateSnapshotsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.GetUpdateSnapshotsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.GetUpdateSnapshotsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.GetUpdateSnapshotsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSnapshotsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.pangolin.protos.UpdateSnapshotObject.serializeBinaryToWriter
    );
  }
};


/**
 * repeated UpdateSnapshotObject snapshots = 1;
 * @return {!Array<!proto.pangolin.protos.UpdateSnapshotObject>}
 */
proto.pangolin.protos.GetUpdateSnapshotsResponse.prototype.getSnapshotsList = function() {
  return /** @type{!Array<!proto.pangolin.protos.UpdateSnapshotObject>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.pangolin.protos.UpdateSnapshotObject, 1));
};


/**
 * @param {!Array<!proto.pangolin.protos.UpdateSnapshotObject>} value
 * @return {!proto.pangolin.protos.GetUpdateSnapshotsResponse} returns this
*/
proto.pangolin.protos.GetUpdateSnapshotsResponse.prototype.setSnapshotsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.pangolin.protos.UpdateSnapshotObject=} opt_value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.UpdateSnapshotObject}
 */
proto.pangolin.protos.GetUpdateSnapshotsResponse.prototype.addSnapshots = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.pangolin.protos.UpdateSnapshotObject, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.GetUpdateSnapshotsResponse} returns this
 */
proto.pangolin.protos.GetUpdateSnapshotsResponse.prototype.clearSnapshotsList = function() {
  return this.setSnapshotsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.GetUpdateSnapshotResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.GetUpdateSnapshotResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.GetUpdateSnapshotResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.GetUpdateSnapshotResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    snapshot: (f = msg.getSnapshot()) && proto.pangolin.protos.UpdateSnapshotObject.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.GetUpdateSnapshotResponse}
 */
proto.pangolin.protos.GetUpdateSnapshotResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.GetUpdateSnapshotResponse;
  return proto.pangolin.protos.GetUpdateSnapshotResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.GetUpdateSnapshotResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.GetUpdateSnapshotResponse}
 */
proto.pangolin.protos.GetUpdateSnapshotResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.UpdateSnapshotObject;
      reader.readMessage(value,proto.pangolin.protos.UpdateSnapshotObject.deserializeBinaryFromReader);
      msg.setSnapshot(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.GetUpdateSnapshotResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.GetUpdateSnapshotResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.GetUpdateSnapshotResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.GetUpdateSnapshotResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSnapshot();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pangolin.protos.UpdateSnapshotObject.serializeBinaryToWriter
    );
  }
};


/**
 * optional UpdateSnapshotObject snapshot = 1;
 * @return {?proto.pangolin.protos.UpdateSnapshotObject}
 */
proto.pangolin.protos.GetUpdateSnapshotResponse.prototype.getSnapshot = function() {
  return /** @type{?proto.pangolin.protos.UpdateSnapshotObject} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.UpdateSnapshotObject, 1));
};


/**
 * @param {?proto.pangolin.protos.UpdateSnapshotObject|undefined} value
 * @return {!proto.pangolin.protos.GetUpdateSnapshotResponse} returns this
*/
proto.pangolin.protos.GetUpdateSnapshotResponse.prototype.setSnapshot = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pangolin.protos.GetUpdateSnapshotResponse} returns this
 */
proto.pangolin.protos.GetUpdateSnapshotResponse.prototype.clearSnapshot = function() {
  return this.setSnapshot(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.GetUpdateSnapshotResponse.prototype.hasSnapshot = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.DeleteUpdateSnapshotRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.DeleteUpdateSnapshotRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.DeleteUpdateSnapshotRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.DeleteUpdateSnapshotRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    password: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.DeleteUpdateSnapshotRequest}
 */
proto.pangolin.protos.DeleteUpdateSnapshotRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.DeleteUpdateSnapshotRequest;
  return proto.pangolin.protos.DeleteUpdateSnapshotRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.DeleteUpdateSnapshotRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.DeleteUpdateSnapshotRequest}
 */
proto.pangolin.protos.DeleteUpdateSnapshotRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPassword(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.DeleteUpdateSnapshotRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.DeleteUpdateSnapshotRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.DeleteUpdateSnapshotRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.DeleteUpdateSnapshotRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string password = 1;
 * @return {string}
 */
proto.pangolin.protos.DeleteUpdateSnapshotRequest.prototype.getPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.DeleteUpdateSnapshotRequest} returns this
 */
proto.pangolin.protos.DeleteUpdateSnapshotRequest.prototype.setPassword = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.DeleteUpdateSnapshotRequest} returns this
 */
proto.pangolin.protos.DeleteUpdateSnapshotRequest.prototype.clearPassword = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.DeleteUpdateSnapshotRequest.prototype.hasPassword = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.UploadStartUpdateSnapshotRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.UploadStartUpdateSnapshotRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.UploadStartUpdateSnapshotRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.UploadStartUpdateSnapshotRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    releaseId: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
    upgradeId: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.UploadStartUpdateSnapshotRequest}
 */
proto.pangolin.protos.UploadStartUpdateSnapshotRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.UploadStartUpdateSnapshotRequest;
  return proto.pangolin.protos.UploadStartUpdateSnapshotRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.UploadStartUpdateSnapshotRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.UploadStartUpdateSnapshotRequest}
 */
proto.pangolin.protos.UploadStartUpdateSnapshotRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setReleaseId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUpgradeId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.UploadStartUpdateSnapshotRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.UploadStartUpdateSnapshotRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.UploadStartUpdateSnapshotRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.UploadStartUpdateSnapshotRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string release_id = 1;
 * @return {string}
 */
proto.pangolin.protos.UploadStartUpdateSnapshotRequest.prototype.getReleaseId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.UploadStartUpdateSnapshotRequest} returns this
 */
proto.pangolin.protos.UploadStartUpdateSnapshotRequest.prototype.setReleaseId = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.UploadStartUpdateSnapshotRequest} returns this
 */
proto.pangolin.protos.UploadStartUpdateSnapshotRequest.prototype.clearReleaseId = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.UploadStartUpdateSnapshotRequest.prototype.hasReleaseId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string upgrade_id = 2;
 * @return {string}
 */
proto.pangolin.protos.UploadStartUpdateSnapshotRequest.prototype.getUpgradeId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.UploadStartUpdateSnapshotRequest} returns this
 */
proto.pangolin.protos.UploadStartUpdateSnapshotRequest.prototype.setUpgradeId = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.UploadStartUpdateSnapshotRequest} returns this
 */
proto.pangolin.protos.UploadStartUpdateSnapshotRequest.prototype.clearUpgradeId = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.UploadStartUpdateSnapshotRequest.prototype.hasUpgradeId = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.UploadStartUpdateSnapshotResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.UploadStartUpdateSnapshotResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.UploadStartUpdateSnapshotResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.UploadStartUpdateSnapshotResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    snapshotId: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
    pspUrl: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
    pspFields: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.UploadStartUpdateSnapshotResponse}
 */
proto.pangolin.protos.UploadStartUpdateSnapshotResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.UploadStartUpdateSnapshotResponse;
  return proto.pangolin.protos.UploadStartUpdateSnapshotResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.UploadStartUpdateSnapshotResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.UploadStartUpdateSnapshotResponse}
 */
proto.pangolin.protos.UploadStartUpdateSnapshotResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSnapshotId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPspUrl(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPspFields(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.UploadStartUpdateSnapshotResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.UploadStartUpdateSnapshotResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.UploadStartUpdateSnapshotResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.UploadStartUpdateSnapshotResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string snapshot_id = 1;
 * @return {string}
 */
proto.pangolin.protos.UploadStartUpdateSnapshotResponse.prototype.getSnapshotId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.UploadStartUpdateSnapshotResponse} returns this
 */
proto.pangolin.protos.UploadStartUpdateSnapshotResponse.prototype.setSnapshotId = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.UploadStartUpdateSnapshotResponse} returns this
 */
proto.pangolin.protos.UploadStartUpdateSnapshotResponse.prototype.clearSnapshotId = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.UploadStartUpdateSnapshotResponse.prototype.hasSnapshotId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string psp_url = 2;
 * @return {string}
 */
proto.pangolin.protos.UploadStartUpdateSnapshotResponse.prototype.getPspUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.UploadStartUpdateSnapshotResponse} returns this
 */
proto.pangolin.protos.UploadStartUpdateSnapshotResponse.prototype.setPspUrl = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.UploadStartUpdateSnapshotResponse} returns this
 */
proto.pangolin.protos.UploadStartUpdateSnapshotResponse.prototype.clearPspUrl = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.UploadStartUpdateSnapshotResponse.prototype.hasPspUrl = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string psp_fields = 3;
 * @return {string}
 */
proto.pangolin.protos.UploadStartUpdateSnapshotResponse.prototype.getPspFields = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.UploadStartUpdateSnapshotResponse} returns this
 */
proto.pangolin.protos.UploadStartUpdateSnapshotResponse.prototype.setPspFields = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.UploadStartUpdateSnapshotResponse} returns this
 */
proto.pangolin.protos.UploadStartUpdateSnapshotResponse.prototype.clearPspFields = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.UploadStartUpdateSnapshotResponse.prototype.hasPspFields = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.UploadFinishUpdateSnapshotRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.UploadFinishUpdateSnapshotRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.UploadFinishUpdateSnapshotRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.UploadFinishUpdateSnapshotRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    p7zSha256: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.UploadFinishUpdateSnapshotRequest}
 */
proto.pangolin.protos.UploadFinishUpdateSnapshotRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.UploadFinishUpdateSnapshotRequest;
  return proto.pangolin.protos.UploadFinishUpdateSnapshotRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.UploadFinishUpdateSnapshotRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.UploadFinishUpdateSnapshotRequest}
 */
proto.pangolin.protos.UploadFinishUpdateSnapshotRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setP7zSha256(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.UploadFinishUpdateSnapshotRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.UploadFinishUpdateSnapshotRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.UploadFinishUpdateSnapshotRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.UploadFinishUpdateSnapshotRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string p7z_sha256 = 1;
 * @return {string}
 */
proto.pangolin.protos.UploadFinishUpdateSnapshotRequest.prototype.getP7zSha256 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.UploadFinishUpdateSnapshotRequest} returns this
 */
proto.pangolin.protos.UploadFinishUpdateSnapshotRequest.prototype.setP7zSha256 = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.UploadFinishUpdateSnapshotRequest} returns this
 */
proto.pangolin.protos.UploadFinishUpdateSnapshotRequest.prototype.clearP7zSha256 = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.UploadFinishUpdateSnapshotRequest.prototype.hasP7zSha256 = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.DownloadUpdateSnapshotResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.DownloadUpdateSnapshotResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.DownloadUpdateSnapshotResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.DownloadUpdateSnapshotResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    psgUrl: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
    p7zSha256: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.DownloadUpdateSnapshotResponse}
 */
proto.pangolin.protos.DownloadUpdateSnapshotResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.DownloadUpdateSnapshotResponse;
  return proto.pangolin.protos.DownloadUpdateSnapshotResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.DownloadUpdateSnapshotResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.DownloadUpdateSnapshotResponse}
 */
proto.pangolin.protos.DownloadUpdateSnapshotResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPsgUrl(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setP7zSha256(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.DownloadUpdateSnapshotResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.DownloadUpdateSnapshotResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.DownloadUpdateSnapshotResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.DownloadUpdateSnapshotResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string psg_url = 1;
 * @return {string}
 */
proto.pangolin.protos.DownloadUpdateSnapshotResponse.prototype.getPsgUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.DownloadUpdateSnapshotResponse} returns this
 */
proto.pangolin.protos.DownloadUpdateSnapshotResponse.prototype.setPsgUrl = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.DownloadUpdateSnapshotResponse} returns this
 */
proto.pangolin.protos.DownloadUpdateSnapshotResponse.prototype.clearPsgUrl = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.DownloadUpdateSnapshotResponse.prototype.hasPsgUrl = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string p7z_sha256 = 2;
 * @return {string}
 */
proto.pangolin.protos.DownloadUpdateSnapshotResponse.prototype.getP7zSha256 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.DownloadUpdateSnapshotResponse} returns this
 */
proto.pangolin.protos.DownloadUpdateSnapshotResponse.prototype.setP7zSha256 = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.DownloadUpdateSnapshotResponse} returns this
 */
proto.pangolin.protos.DownloadUpdateSnapshotResponse.prototype.clearP7zSha256 = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.DownloadUpdateSnapshotResponse.prototype.hasP7zSha256 = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pangolin.protos.GetUpdateHistoryResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.GetUpdateHistoryResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.GetUpdateHistoryResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.GetUpdateHistoryResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.GetUpdateHistoryResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    historyList: jspb.Message.toObjectList(msg.getHistoryList(),
    proto.pangolin.protos.UpdateHistoryObject.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.GetUpdateHistoryResponse}
 */
proto.pangolin.protos.GetUpdateHistoryResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.GetUpdateHistoryResponse;
  return proto.pangolin.protos.GetUpdateHistoryResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.GetUpdateHistoryResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.GetUpdateHistoryResponse}
 */
proto.pangolin.protos.GetUpdateHistoryResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.UpdateHistoryObject;
      reader.readMessage(value,proto.pangolin.protos.UpdateHistoryObject.deserializeBinaryFromReader);
      msg.addHistory(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.GetUpdateHistoryResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.GetUpdateHistoryResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.GetUpdateHistoryResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.GetUpdateHistoryResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHistoryList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.pangolin.protos.UpdateHistoryObject.serializeBinaryToWriter
    );
  }
};


/**
 * repeated UpdateHistoryObject history = 1;
 * @return {!Array<!proto.pangolin.protos.UpdateHistoryObject>}
 */
proto.pangolin.protos.GetUpdateHistoryResponse.prototype.getHistoryList = function() {
  return /** @type{!Array<!proto.pangolin.protos.UpdateHistoryObject>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.pangolin.protos.UpdateHistoryObject, 1));
};


/**
 * @param {!Array<!proto.pangolin.protos.UpdateHistoryObject>} value
 * @return {!proto.pangolin.protos.GetUpdateHistoryResponse} returns this
*/
proto.pangolin.protos.GetUpdateHistoryResponse.prototype.setHistoryList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.pangolin.protos.UpdateHistoryObject=} opt_value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.UpdateHistoryObject}
 */
proto.pangolin.protos.GetUpdateHistoryResponse.prototype.addHistory = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.pangolin.protos.UpdateHistoryObject, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.GetUpdateHistoryResponse} returns this
 */
proto.pangolin.protos.GetUpdateHistoryResponse.prototype.clearHistoryList = function() {
  return this.setHistoryList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.GetUpdateUpgradeResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.GetUpdateUpgradeResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.GetUpdateUpgradeResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.GetUpdateUpgradeResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    upgrade: (f = msg.getUpgrade()) && proto.pangolin.protos.UpdateUpgradeObject.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.GetUpdateUpgradeResponse}
 */
proto.pangolin.protos.GetUpdateUpgradeResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.GetUpdateUpgradeResponse;
  return proto.pangolin.protos.GetUpdateUpgradeResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.GetUpdateUpgradeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.GetUpdateUpgradeResponse}
 */
proto.pangolin.protos.GetUpdateUpgradeResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.UpdateUpgradeObject;
      reader.readMessage(value,proto.pangolin.protos.UpdateUpgradeObject.deserializeBinaryFromReader);
      msg.setUpgrade(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.GetUpdateUpgradeResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.GetUpdateUpgradeResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.GetUpdateUpgradeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.GetUpdateUpgradeResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUpgrade();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pangolin.protos.UpdateUpgradeObject.serializeBinaryToWriter
    );
  }
};


/**
 * optional UpdateUpgradeObject upgrade = 1;
 * @return {?proto.pangolin.protos.UpdateUpgradeObject}
 */
proto.pangolin.protos.GetUpdateUpgradeResponse.prototype.getUpgrade = function() {
  return /** @type{?proto.pangolin.protos.UpdateUpgradeObject} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.UpdateUpgradeObject, 1));
};


/**
 * @param {?proto.pangolin.protos.UpdateUpgradeObject|undefined} value
 * @return {!proto.pangolin.protos.GetUpdateUpgradeResponse} returns this
*/
proto.pangolin.protos.GetUpdateUpgradeResponse.prototype.setUpgrade = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pangolin.protos.GetUpdateUpgradeResponse} returns this
 */
proto.pangolin.protos.GetUpdateUpgradeResponse.prototype.clearUpgrade = function() {
  return this.setUpgrade(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.GetUpdateUpgradeResponse.prototype.hasUpgrade = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.CreateUpdateUpgradeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.CreateUpdateUpgradeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.CreateUpdateUpgradeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.CreateUpdateUpgradeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    releaseId: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
    password: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.CreateUpdateUpgradeRequest}
 */
proto.pangolin.protos.CreateUpdateUpgradeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.CreateUpdateUpgradeRequest;
  return proto.pangolin.protos.CreateUpdateUpgradeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.CreateUpdateUpgradeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.CreateUpdateUpgradeRequest}
 */
proto.pangolin.protos.CreateUpdateUpgradeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setReleaseId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPassword(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.CreateUpdateUpgradeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.CreateUpdateUpgradeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.CreateUpdateUpgradeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.CreateUpdateUpgradeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string release_id = 1;
 * @return {string}
 */
proto.pangolin.protos.CreateUpdateUpgradeRequest.prototype.getReleaseId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.CreateUpdateUpgradeRequest} returns this
 */
proto.pangolin.protos.CreateUpdateUpgradeRequest.prototype.setReleaseId = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.CreateUpdateUpgradeRequest} returns this
 */
proto.pangolin.protos.CreateUpdateUpgradeRequest.prototype.clearReleaseId = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.CreateUpdateUpgradeRequest.prototype.hasReleaseId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string password = 2;
 * @return {string}
 */
proto.pangolin.protos.CreateUpdateUpgradeRequest.prototype.getPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.CreateUpdateUpgradeRequest} returns this
 */
proto.pangolin.protos.CreateUpdateUpgradeRequest.prototype.setPassword = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.CreateUpdateUpgradeRequest} returns this
 */
proto.pangolin.protos.CreateUpdateUpgradeRequest.prototype.clearPassword = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.CreateUpdateUpgradeRequest.prototype.hasPassword = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.CreateUpdateUpgradeResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.CreateUpdateUpgradeResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.CreateUpdateUpgradeResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.CreateUpdateUpgradeResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    upgrade: (f = msg.getUpgrade()) && proto.pangolin.protos.UpdateUpgradeObject.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.CreateUpdateUpgradeResponse}
 */
proto.pangolin.protos.CreateUpdateUpgradeResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.CreateUpdateUpgradeResponse;
  return proto.pangolin.protos.CreateUpdateUpgradeResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.CreateUpdateUpgradeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.CreateUpdateUpgradeResponse}
 */
proto.pangolin.protos.CreateUpdateUpgradeResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.UpdateUpgradeObject;
      reader.readMessage(value,proto.pangolin.protos.UpdateUpgradeObject.deserializeBinaryFromReader);
      msg.setUpgrade(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.CreateUpdateUpgradeResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.CreateUpdateUpgradeResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.CreateUpdateUpgradeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.CreateUpdateUpgradeResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUpgrade();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pangolin.protos.UpdateUpgradeObject.serializeBinaryToWriter
    );
  }
};


/**
 * optional UpdateUpgradeObject upgrade = 1;
 * @return {?proto.pangolin.protos.UpdateUpgradeObject}
 */
proto.pangolin.protos.CreateUpdateUpgradeResponse.prototype.getUpgrade = function() {
  return /** @type{?proto.pangolin.protos.UpdateUpgradeObject} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.UpdateUpgradeObject, 1));
};


/**
 * @param {?proto.pangolin.protos.UpdateUpgradeObject|undefined} value
 * @return {!proto.pangolin.protos.CreateUpdateUpgradeResponse} returns this
*/
proto.pangolin.protos.CreateUpdateUpgradeResponse.prototype.setUpgrade = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pangolin.protos.CreateUpdateUpgradeResponse} returns this
 */
proto.pangolin.protos.CreateUpdateUpgradeResponse.prototype.clearUpgrade = function() {
  return this.setUpgrade(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.CreateUpdateUpgradeResponse.prototype.hasUpgrade = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.SetUpdateUpgradeStatusRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.SetUpdateUpgradeStatusRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.SetUpdateUpgradeStatusRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.SetUpdateUpgradeStatusRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    status: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.SetUpdateUpgradeStatusRequest}
 */
proto.pangolin.protos.SetUpdateUpgradeStatusRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.SetUpdateUpgradeStatusRequest;
  return proto.pangolin.protos.SetUpdateUpgradeStatusRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.SetUpdateUpgradeStatusRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.SetUpdateUpgradeStatusRequest}
 */
proto.pangolin.protos.SetUpdateUpgradeStatusRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.pangolin.protos.UpdateUpgradeStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.SetUpdateUpgradeStatusRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.SetUpdateUpgradeStatusRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.SetUpdateUpgradeStatusRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.SetUpdateUpgradeStatusRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {!proto.pangolin.protos.UpdateUpgradeStatus} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * optional UpdateUpgradeStatus status = 1;
 * @return {!proto.pangolin.protos.UpdateUpgradeStatus}
 */
proto.pangolin.protos.SetUpdateUpgradeStatusRequest.prototype.getStatus = function() {
  return /** @type {!proto.pangolin.protos.UpdateUpgradeStatus} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.pangolin.protos.UpdateUpgradeStatus} value
 * @return {!proto.pangolin.protos.SetUpdateUpgradeStatusRequest} returns this
 */
proto.pangolin.protos.SetUpdateUpgradeStatusRequest.prototype.setStatus = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.SetUpdateUpgradeStatusRequest} returns this
 */
proto.pangolin.protos.SetUpdateUpgradeStatusRequest.prototype.clearStatus = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.SetUpdateUpgradeStatusRequest.prototype.hasStatus = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.GetUpdateRestoreResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.GetUpdateRestoreResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.GetUpdateRestoreResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.GetUpdateRestoreResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    restore: (f = msg.getRestore()) && proto.pangolin.protos.UpdateRestoreObject.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.GetUpdateRestoreResponse}
 */
proto.pangolin.protos.GetUpdateRestoreResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.GetUpdateRestoreResponse;
  return proto.pangolin.protos.GetUpdateRestoreResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.GetUpdateRestoreResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.GetUpdateRestoreResponse}
 */
proto.pangolin.protos.GetUpdateRestoreResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.UpdateRestoreObject;
      reader.readMessage(value,proto.pangolin.protos.UpdateRestoreObject.deserializeBinaryFromReader);
      msg.setRestore(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.GetUpdateRestoreResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.GetUpdateRestoreResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.GetUpdateRestoreResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.GetUpdateRestoreResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRestore();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pangolin.protos.UpdateRestoreObject.serializeBinaryToWriter
    );
  }
};


/**
 * optional UpdateRestoreObject restore = 1;
 * @return {?proto.pangolin.protos.UpdateRestoreObject}
 */
proto.pangolin.protos.GetUpdateRestoreResponse.prototype.getRestore = function() {
  return /** @type{?proto.pangolin.protos.UpdateRestoreObject} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.UpdateRestoreObject, 1));
};


/**
 * @param {?proto.pangolin.protos.UpdateRestoreObject|undefined} value
 * @return {!proto.pangolin.protos.GetUpdateRestoreResponse} returns this
*/
proto.pangolin.protos.GetUpdateRestoreResponse.prototype.setRestore = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pangolin.protos.GetUpdateRestoreResponse} returns this
 */
proto.pangolin.protos.GetUpdateRestoreResponse.prototype.clearRestore = function() {
  return this.setRestore(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.GetUpdateRestoreResponse.prototype.hasRestore = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.CreateUpdateRestoreRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.CreateUpdateRestoreRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.CreateUpdateRestoreRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.CreateUpdateRestoreRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    snapshotId: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
    password: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.CreateUpdateRestoreRequest}
 */
proto.pangolin.protos.CreateUpdateRestoreRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.CreateUpdateRestoreRequest;
  return proto.pangolin.protos.CreateUpdateRestoreRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.CreateUpdateRestoreRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.CreateUpdateRestoreRequest}
 */
proto.pangolin.protos.CreateUpdateRestoreRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSnapshotId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPassword(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.CreateUpdateRestoreRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.CreateUpdateRestoreRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.CreateUpdateRestoreRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.CreateUpdateRestoreRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string snapshot_id = 1;
 * @return {string}
 */
proto.pangolin.protos.CreateUpdateRestoreRequest.prototype.getSnapshotId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.CreateUpdateRestoreRequest} returns this
 */
proto.pangolin.protos.CreateUpdateRestoreRequest.prototype.setSnapshotId = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.CreateUpdateRestoreRequest} returns this
 */
proto.pangolin.protos.CreateUpdateRestoreRequest.prototype.clearSnapshotId = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.CreateUpdateRestoreRequest.prototype.hasSnapshotId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string password = 2;
 * @return {string}
 */
proto.pangolin.protos.CreateUpdateRestoreRequest.prototype.getPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.CreateUpdateRestoreRequest} returns this
 */
proto.pangolin.protos.CreateUpdateRestoreRequest.prototype.setPassword = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.CreateUpdateRestoreRequest} returns this
 */
proto.pangolin.protos.CreateUpdateRestoreRequest.prototype.clearPassword = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.CreateUpdateRestoreRequest.prototype.hasPassword = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.CreateUpdateRestoreResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.CreateUpdateRestoreResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.CreateUpdateRestoreResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.CreateUpdateRestoreResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    restore: (f = msg.getRestore()) && proto.pangolin.protos.UpdateRestoreObject.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.CreateUpdateRestoreResponse}
 */
proto.pangolin.protos.CreateUpdateRestoreResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.CreateUpdateRestoreResponse;
  return proto.pangolin.protos.CreateUpdateRestoreResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.CreateUpdateRestoreResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.CreateUpdateRestoreResponse}
 */
proto.pangolin.protos.CreateUpdateRestoreResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.UpdateRestoreObject;
      reader.readMessage(value,proto.pangolin.protos.UpdateRestoreObject.deserializeBinaryFromReader);
      msg.setRestore(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.CreateUpdateRestoreResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.CreateUpdateRestoreResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.CreateUpdateRestoreResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.CreateUpdateRestoreResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRestore();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pangolin.protos.UpdateRestoreObject.serializeBinaryToWriter
    );
  }
};


/**
 * optional UpdateRestoreObject restore = 1;
 * @return {?proto.pangolin.protos.UpdateRestoreObject}
 */
proto.pangolin.protos.CreateUpdateRestoreResponse.prototype.getRestore = function() {
  return /** @type{?proto.pangolin.protos.UpdateRestoreObject} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.UpdateRestoreObject, 1));
};


/**
 * @param {?proto.pangolin.protos.UpdateRestoreObject|undefined} value
 * @return {!proto.pangolin.protos.CreateUpdateRestoreResponse} returns this
*/
proto.pangolin.protos.CreateUpdateRestoreResponse.prototype.setRestore = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pangolin.protos.CreateUpdateRestoreResponse} returns this
 */
proto.pangolin.protos.CreateUpdateRestoreResponse.prototype.clearRestore = function() {
  return this.setRestore(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.CreateUpdateRestoreResponse.prototype.hasRestore = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.SetUpdateRestoreStatusRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.SetUpdateRestoreStatusRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.SetUpdateRestoreStatusRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.SetUpdateRestoreStatusRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    status: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.SetUpdateRestoreStatusRequest}
 */
proto.pangolin.protos.SetUpdateRestoreStatusRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.SetUpdateRestoreStatusRequest;
  return proto.pangolin.protos.SetUpdateRestoreStatusRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.SetUpdateRestoreStatusRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.SetUpdateRestoreStatusRequest}
 */
proto.pangolin.protos.SetUpdateRestoreStatusRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.pangolin.protos.UpdateRestoreStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.SetUpdateRestoreStatusRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.SetUpdateRestoreStatusRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.SetUpdateRestoreStatusRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.SetUpdateRestoreStatusRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {!proto.pangolin.protos.UpdateRestoreStatus} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * optional UpdateRestoreStatus status = 1;
 * @return {!proto.pangolin.protos.UpdateRestoreStatus}
 */
proto.pangolin.protos.SetUpdateRestoreStatusRequest.prototype.getStatus = function() {
  return /** @type {!proto.pangolin.protos.UpdateRestoreStatus} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.pangolin.protos.UpdateRestoreStatus} value
 * @return {!proto.pangolin.protos.SetUpdateRestoreStatusRequest} returns this
 */
proto.pangolin.protos.SetUpdateRestoreStatusRequest.prototype.setStatus = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.SetUpdateRestoreStatusRequest} returns this
 */
proto.pangolin.protos.SetUpdateRestoreStatusRequest.prototype.clearStatus = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.SetUpdateRestoreStatusRequest.prototype.hasStatus = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * @enum {number}
 */
proto.pangolin.protos.UpdateUpgradeStatus = {
  UPDATE_UPGRADE_STATUS_PENDING: 0,
  UPDATE_UPGRADE_STATUS_DOWNLOAD: 1,
  UPDATE_UPGRADE_STATUS_INSTALL: 2,
  UPDATE_UPGRADE_STATUS_REBOOT: 3,
  UPDATE_UPGRADE_STATUS_LAUNCH: 4,
  UPDATE_UPGRADE_STATUS_BACKUP: 5,
  UPDATE_UPGRADE_STATUS_COMPLETED: 6,
  UPDATE_UPGRADE_STATUS_CANCELLED: 7,
  UPDATE_UPGRADE_STATUS_SKIPPED: 8,
  UPDATE_UPGRADE_STATUS_FAILED: 9
};

/**
 * @enum {number}
 */
proto.pangolin.protos.UpdateRestoreStatus = {
  UPDATE_RESTORE_STATUS_PENDING: 0,
  UPDATE_RESTORE_STATUS_ROLLBACK: 1,
  UPDATE_RESTORE_STATUS_DISPATCH: 2,
  UPDATE_RESTORE_STATUS_DOWNLOAD: 3,
  UPDATE_RESTORE_STATUS_INSTALL: 4,
  UPDATE_RESTORE_STATUS_REBOOT: 5,
  UPDATE_RESTORE_STATUS_COMPLETED: 6,
  UPDATE_RESTORE_STATUS_CANCELLED: 7,
  UPDATE_RESTORE_STATUS_SKIPPED: 8,
  UPDATE_RESTORE_STATUS_FAILED: 9
};

/**
 * @enum {number}
 */
proto.pangolin.protos.UpdateHistoryType = {
  UPDATE_HISTORY_TYPE_UPGRADE: 0,
  UPDATE_HISTORY_TYPE_RESTORE: 1
};

goog.object.extend(exports, proto.pangolin.protos);
